'use client';

import type { ReactNode } from 'react';
import { useCartPaymentFormStore } from 'stores/cart';
import { CartStepLayout } from '../../../partials/CartStepLayout';
import { BackButton } from '../../../partials/BackButton';
import { ProceedButton } from '../../../partials/ProceedButtonStream/ProceedButton';
import { CartMutationErrorSnackbar } from '../../../partials/CartMutationErrorSnackbar';
import { trackBackToAddressClick } from '../../../analytics/payment';
import { useSetPayment } from '../../../hooks/payment';
import type { CartRoutes } from '../../../types';
import { PAYMENT_FORM_ID, PAYMENT_TITLE_ID } from '../../constants';

interface CartPaymentShellProps {
  constants: Record<string, string>;
  routes: Pick<CartRoutes, 'address' | 'checkout'>;
  children: ReactNode;
}

export function CartPaymentShell({ constants, routes, children }: CartPaymentShellProps) {
  const hasPaymentMethods = useCartPaymentFormStore(store => store.hasPaymentMethods);
  const { formAction, isPending } = useSetPayment({ constants, checkoutRoute: routes.checkout });

  const continueButton = (
    <ProceedButton isBusy={isPending} disabled={!hasPaymentMethods} type="submit">
      {constants['i18n_continue-to-checkout']}
    </ProceedButton>
  );

  return (
    <form id={PAYMENT_FORM_ID} action={formAction}>
      <CartStepLayout
        title={constants['i18n_please-choose-your-payment']}
        titleId={PAYMENT_TITLE_ID}
        stepHeader={continueButton}
        stepFooter={
          <>
            {continueButton}
            <BackButton
              label={constants['i18n_back-to-address']}
              href={routes.address}
              onClick={trackBackToAddressClick}
            />
          </>
        }
      >
        {children}
      </CartStepLayout>
      <CartMutationErrorSnackbar />
    </form>
  );
}
